export const faqs = [
  {
    question: '91c是什么？它主要解决什么问题？',
    answer: '91c是一款综合性的智能数据管理与分析平台，旨在帮助个人用户和企业高效地处理、分析和利用数据。它整合了数据看板、智能分析、自动化工作流和团队协作等核心功能，让用户无需专业技术背景也能轻松驾驭数据，做出更明智的决策。',
  },
  {
    question: '91c支持哪些平台？可以在手机上使用吗？',
    answer: '91c支持桌面端（Windows、macOS、Linux）和移动端（iOS、Android）。桌面端通过浏览器访问即可，无需安装；移动端我们提供了官方App，在各大应用商店搜索"91c"即可下载。两个平台数据完全同步。',
  },
  {
    question: '91c的收费标准是怎样的？有免费版吗？',
    answer: '91c提供多种套餐选择：免费版包含基础功能，适合个人用户入门体验；专业版每月99元，提供完整功能访问；企业版提供定制化服务，价格根据团队规模和使用需求灵活定价。所有付费套餐均支持7天无理由退款。',
  },
  {
    question: '我的数据在91c上安全吗？',
    answer: '数据安全是91c的最高优先级。我们采用企业级安全标准，包括传输加密（TLS 1.3）、存储加密（AES-256）、双重验证、IP白名单等多重保护措施。同时，我们通过了ISO 27001信息安全认证，定期进行第三方安全审计，确保您的数据安全无忧。',
  },
  {
    question: '如何将现有系统的数据导入91c？',
    answer: '91c提供了多种数据导入方式：支持CSV、Excel、JSON等常见格式的文件上传；提供RESTful API接口实现自动化数据同步；对于常用第三方工具（如CRM、ERP系统），我们提供了一键导入模板。详细操作可参考帮助文档中的数据导入指南。',
  },
  {
    question: '91c支持团队协作吗？如何管理团队权限？',
    answer: '91c提供了完善的团队协作功能。您可以创建团队空间，邀请成员加入，设置不同角色的权限（管理员、编辑者、查看者等）。支持实时多人协作编辑、评论讨论和变更历史追踪。企业版还支持与LDAP/AD集成实现统一身份认证管理。',
  },
  {
    question: '遇到问题如何获取帮助？',
    answer: '您可以通过多种渠道获取帮助：访问帮助中心查看详细文档和教程视频、在社区论坛与其他用户交流经验、通过在线客服实时咨询、或发送邮件至客服团队。企业版用户还享有专属客户成功经理的一对一支持服务。',
  },
  {
    question: '91c可以进行二次开发或定制吗？',
    answer: '可以的。91c提供了功能强大的RESTful API和Webhook，开发者可以在此基础上进行深度集成和二次开发。企业版用户还可以根据业务需求定制专属功能和界面。我们提供完整的技术文档和开发者支持。',
  },
];